import axios from "axios";
import store from "@/store";
import router from "@/router";
import qs from "qs";

const instance = axios.create({
  baseURL: "https://api.gomagby.com",
  paramsSerializer: (params) => {
    return qs.stringify(params, {
      arrayFormat: "repeat",
      encode: false
    })
  }
})

instance.interceptors.request.use((config) => {
    const token = store.state.user.token

    if (token) {
      config.headers = config.headers || {}
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  (error) => Promise.reject(error)
)


instance.interceptors.response.use(undefined, async (err) => {
  if (err.response.status === 401 && err.response.config && !err.response.config.__isRetryRequest) {
    await store.dispatch('user/logout')
    await router.push('/login')
  }

  throw err;
})

export default instance;